"use client"

// import { TESTIMONIAL_BG } from '@/lib/constant'
import React from 'react'
import MaxWidthContainer from './max-width-container'
import CustomLabel from '../ui/custom-label'
import { api } from '@/trpc/react'
import { Skeleton } from '../ui/skeleton'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
// import required modules
import { Navigation } from 'swiper/modules';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import TestimonialCard from './testimonial-card'
// import { ImageLoader } from '../ui/image-loader'

export default function Testimonials() {
    const { data, isLoading } = api.testimonial.get_testimonials.useQuery()

    if (isLoading) return (
        <section className='relative py-8 md:py-12'>
            <Skeleton className='w-full h-[40rem] bg-gray-300' />
        </section>
    )

    if (!data || data.length < 1) return null

    return (
        <section className='relative py-8 md:py-12 bg-gradient-to-b from-custom-primary-dark/5 to-transparent'>
            {/* <ImageLoader src={TESTIMONIAL_BG} alt='' fill className='object-cover' /> */}
            {/* <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#007A7A]/5 to-white" /> */}
            <MaxWidthContainer className='relative space-y-5'>
                <CustomLabel label='Review & Testimonials' white className='text-black text-2xl md:text-3xl lg:leading-snug' />
                <div className='relative h-full w-full'>
                    <Swiper
                        breakpoints={{
                            200: {
                                slidesPerView: 1,
                                spaceBetween: 10
                            },
                            350: {
                                slidesPerView: 1.1,
                                spaceBetween: 12
                            },
                            420: {
                                slidesPerView: 1.2,
                                spaceBetween: 16
                            },
                            450: {
                                slidesPerView: 1.3,
                                spaceBetween: 16
                            },
                            520: {
                                slidesPerView: 1.5,
                                spaceBetween: 16
                            },
                            580: {
                                slidesPerView: 1.8,
                                spaceBetween: 16
                            },
                            750: {
                                slidesPerView: 2,
                                spaceBetween: 20
                            },
                            850: {
                                slidesPerView: 2.4,
                                spaceBetween: 24
                            },
                            1000: {
                                slidesPerView: 2.6,
                                spaceBetween: 24
                            },
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 36
                            },
                        }}
                        navigation={{
                            prevEl: `.testimonialPrev`,
                            nextEl: `.testimonialNext`,
                        }}
                        modules={[Navigation]}
                        className="mySwiper h-full w-full"
                    >
                        {data?.map((data) => (
                            <SwiperSlide key={data.id}>
                                <TestimonialCard data={data} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className='flex flex-row  gap-2.5 absolute -top-14 right-0'>
                        <button className='testimonialPrev lg:h-8 lg:w-8 md:h-7 md:w-7 h-6 w-6 p-0.5 lg:p-1 rounded-full bg-white text-custom-primary hover:bg-custom-primary hover:text-white transition-all duration-300 ease-in-out shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hover:shadow-none disabled:cursor-not-allowed disabled:hover:text-custom-primary disabled:hover:bg-white disabled:hover:shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hidden md:block'><ChevronLeft className='h-full w-full -ml-0.5' strokeWidth={1.5} /></button>
                        <button className='testimonialNext lg:h-8 lg:w-8 md:h-7 md:w-7 h-6 w-6 p-0.5 lg:p-1 rounded-full bg-white text-custom-primary hover:bg-custom-primary hover:text-white transition-all duration-300 ease-in-out shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hover:shadow-none disabled:cursor-not-allowed disabled:hover:text-custom-primary disabled:hover:bg-white disabled:hover:shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hidden md:block'><ChevronRight className='h-full w-full -mr-0.5' strokeWidth={1.5} /></button>
                    </div>
                </div>
            </MaxWidthContainer>
        </section>
    )
}
